<template>
  <el-menu-item :index="getIndex()" :path="getIndex()" :open-mode="menu.openMode">
    <span slot="title">{{menu.title || '未命名菜单'}}</span>
    <i v-if="!menu.isOnlyText" :class="`${menu.icon || 'fa fa-file-o'}`"></i>
  </el-menu-item>
</template>

<script>
import uniqueid from 'lodash.uniqueid'
export default {
  name: 'd2-layout-header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    },
    isMobileLayer: {
      type: Boolean,
      required: false,
    }
  },
  data () {
    return {
      uniqueid: uniqueid('d2-menu-empty-')
    }
  },
  methods: {
      getIndex(){
          return this.getPath() || this.uniqueid
      },
    getPath(){
        if(this.isMobileLayer && this.menu.mobilePath){
            return this.menu.mobilePath
        }else{
            return this.menu.path
        }
    }
  }
}
</script>
